module.exports = __webpack_public_path__ + "static/vocanter-0fbee315b6648dfea629da2680712ccf.jpg";